import { formatTWCurrency } from '../Common/twListHelpers';

export const getPublicPaymentSummaryRows = (data) => {
  const inv = data?.invoice;
  const allocation = data?.allocation;
  const currency = inv?.currency || 'LKR';

  const participantLabel = inv?.participant?.participantType === 'corporate' ? 'Company' : 'Participant';
  const participantName = inv?.participant?.displayName
    || inv?.participant?.companyName
    || data?.participant?.companyName
    || '—';

  const workshopName = inv?.workshopName
    || inv?.workshop?.workshopName
    || allocation?.workshopSnapshot?.workshopName
    || allocation?.workshop?.workshopName
    || '—';

  let scheduleLabel = inv?.scheduleLabel;
  if (!scheduleLabel) {
    const sched = inv?.schedule || allocation?.schedule;
    if (sched) {
      const parts = [sched.scheduleCode, sched.title].filter(Boolean);
      if (sched.startDate) {
        parts.push(new Date(sched.startDate).toLocaleDateString());
      }
      scheduleLabel = parts.join(' — ') || '—';
    } else {
      scheduleLabel = '—';
    }
  }

  return [
    [participantLabel, participantName],
    ['Workshop', workshopName],
    ['Schedule', scheduleLabel],
    ['Grand Total', formatTWCurrency(inv?.grandTotal, currency)],
    ['Amount Paid', formatTWCurrency(inv?.paidAmount, currency)],
    ['Balance Due', formatTWCurrency(inv?.balanceAmount, currency)],
  ];
};
